import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.address',
        defaultMessage: 'Address'
    },
    description: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.description',
        defaultMessage: 'Description'
    },
    businessPursuits: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.businessPursuits',
        defaultMessage: 'Business Pursuits'
    },
    rentedToOthers: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.rentedForResidentialUse',
        defaultMessage: 'Rented to Others'
    },
    isPrimary: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.isPrimary',
        defaultMessage: 'Was the structure originally constructed as a primary residence?'
    },
    limit: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.limit',
        defaultMessage: 'Limit'
    },
    action: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.modalTitle',
        defaultMessage: 'Add Separate Structures - Off Premises'
    },
    addressLine1: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.addressLine1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.addressLine2',
        defaultMessage: 'Address Line 2'
    },
    city: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.city',
        defaultMessage: 'City'
    },
    zipCode: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.zipCode',
        defaultMessage: 'Zip Code'
    },
    state: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.state',
        defaultMessage: 'State'
    },
    addBtn: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.seperateStructsAwayFromResidence.continueBtn',
        defaultMessage: 'Continue'
    },
});
